import React, { useState } from "react";
import { sidebarData } from "../../../hooks/helper";
import { Link, useLocation } from "react-router-dom";

const Sidebar = () => {
  const location = useLocation();
  const [activeMenu, setActiveMenu] = useState(null);
  return (
    <aside
      id="layout-menu"
      class="layout-menu-horizontal menu-horizontal menu flex-grow-0"
      style={{
        userSelect: "none",
        WebkitUserDrag: "none",
        WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
        position: "fixed",
        insetBlockStart: "3.5rem",
      }}
    >
      <div class="d-flex h-100 container-fluid">
        <a href="#" class="menu-horizontal-prev d-none"></a>
        <div class="menu-horizontal-wrapper">
          <ul class="sidebar-menu-cus menu-inner" style={{ marginLeft: "0px" }}>
            {sidebarData.map((item) => (
              <li
                class={`menu-item ${
                  location.pathname === item?.link ? "active" : ""
                } ${activeMenu === item?.id ? "open" : ""}`}
                onMouseEnter={() => setActiveMenu(item?.id)}
                onMouseLeave={() => setActiveMenu(null)}
              >
                {item.subMenu.length > 0 ? (
                  <Link class="menu-link menu-toggle">
                    <i class={`menu-icon icon-base ${item?.icon}`}></i>
                    <div data-i18n={item?.id}>{item.title}</div>
                  </Link>
                ) : (
                  <Link to={item.link} class="menu-link">
                    <i class={`menu-icon icon-base ${item?.icon}`}></i>
                    <div data-i18n={item?.id}>{item.title}</div>
                  </Link>
                )}
                {item.subMenu.length > 0 && (
                  <ul class="menu-sub">
                    {item.subMenu.map((subItem) => (
                      <li
                        class={`menu-item ${
                          location.pathname === subItem?.link ? "active" : ""
                        }`}
                      >
                        <Link to={subItem.link} class="menu-link">
                          <i class="menu-icon icon-base ti ti-point-filled"></i>
                          <div data-i18n="Analytics">{subItem.title}</div>
                        </Link>
                      </li>
                    ))}
                  </ul>
                )}
              </li>
            ))}
          </ul>
        </div>
        <a href="#" class="menu-horizontal-next d-none"></a>
      </div>
    </aside>
  );
};

export default Sidebar;
